// extracted by mini-css-extract-plugin
export default {"function":"styles_function__zz7bw"};